<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"
      ><HeaderContent :tabindex="tabIndex"
    /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <el-row>
        <el-col :span="24" class="scene_top" v-lazy:background-image="imgLink">
          <div class="scene_topContent">
            <h1>中国商业不动产综合服务商</h1>
            <p>Integrative Marketing Expert of Commercial Real Estate</p>
          </div>
        </el-col>
      </el-row>
      <!-- 公司相关信息 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space homePage">
            <div class="homePageOneInfos">
              <ul class="homePageInfo1">
                <li>
                  <p><strong>18</strong><span>个城市子公司</span></p>
                  <p><strong>3300</strong></p>
                </li>
                <li>
                  <p>
                    <strong>30,000，000</strong
                    ><span>官网<br />年均访客数3亿</span>
                  </p>
                  <p>
                    <strong>14</strong
                    ><span>年<br />房地产金融服务<br />经验积累</span>
                  </p>
                </li>
                <li>
                  <p>
                    <strong>25</strong><br /><span>新房代理服务经验积累</span>
                  </p>
                  <p>
                    <span>房屋资产管理服务经验积累</span><strong>18</strong
                    ><span>年</span>
                  </p>
                </li>
                <li>
                  <p>
                    <strong>1,000,000,0<br />00,000</strong
                    ><span>近三年房屋销售总额破万亿</span>
                  </p>
                </li>
                <li>
                  <p>
                    <strong>58,000,000,000</strong
                    ><span>580亿元房屋<br />按揭引荐年成交额</span>
                  </p>
                </li>
              </ul>
              <ul class="homePageInfo2">
                <li>
                  <sub>+</sub>
                  <p>3300家连锁门店</p>
                </li>
                <li><strong>50</strong><sub>+</sub><span>个地区</span></li>
                <li>
                  <strong>9,000，000</strong><span>900万<br />APP总下载量</span>
                </li>
                <li>
                  <strong>3,000，000</strong><span>呼叫中心年呼入量</span>
                </li>
                <li>
                  <strong>19</strong><sub>年</sub
                  ><span>二手房经纪<br />服务经验积累</span>
                </li>
              </ul>
              <ul class="homePageInfo3">
                <li>
                  <p><strong>55000</strong></p>
                  <span>5.5万名经纪人</span>
                </li>
                <li>
                  <strong>1,000,000，000,000</strong
                  ><span>资产<br />管理总值近万亿元</span>
                </li>
                <li><strong>50,000,000</strong><span>服务客户总量</span></li>
                <li>
                  <strong>310,000</strong><span>3.1万套托管房屋套数</span>
                </li>
                <li>
                  <strong>1,500,000</strong
                  ><span>近三年租赁<br />业务签约总单数</span>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 服务体系 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space content_coreTechnology">
            <div class="title">
              <h3>服务体系</h3>
              <i class="lineTitel"></i>
            </div>
            <el-row>
              <div class="serviceSystem">
                <div class="content">
                  <h4>商业策划</h4>
                  <div class="content_coreTechnologyBox">
                    <!-- <img src="~@/assets/images/BOSPictureFive.png" /> -->
                    <img v-lazy="aboutImg.picture1" />
                    <p>
                      市场调研<br />竞争策略<br />建筑规划设计、优化<br />产品设计<br />产品再造<br />招商前置<br />运营前置<br />
                    </p>
                  </div>
                </div>
                <div class="content">
                  <h4>产品营建</h4>
                  <div class="content_coreTechnologyBox">
                    <img v-lazy="aboutImg.picture2" />

                    <!-- <img src="~@/assets/images/BOSPictureFour.png" /> -->
                    <p>
                      整购销售<br />整合营销<br />网络营销<br />移动客户端<br />区域行销<br />电话CALL客<br />中介联动<br />租金预测<br />品牌落位<br />
                    </p>
                  </div>
                </div>
                <div class="content">
                  <h4>专业招商</h4>
                  <div class="content_coreTechnologyBox">
                    <img v-lazy="aboutImg.picture3" />

                    <!-- <img src="~@/assets/images/BOSPictureThree.png" /> -->
                    <p>
                      业态规划<br />商家招商<br />主力商家<br />商家谈判<br />实现溢价<br />
                    </p>
                  </div>
                </div>
                <div class="content">
                  <h4>运营管理</h4>
                  <div class="content_coreTechnologyBox">
                    <img v-lazy="aboutImg.picture4" />

                    <!-- <img src="~@/assets/images/BOSPictureTwo.png" /> -->
                    <p>
                      统一包装<br />统一包租<br />商家调整<br />二次招商<br />新媒体营销<br />跨界营销<br />
                    </p>
                  </div>
                </div>
                <div class="content">
                  <h4>推广服务</h4>
                  <div class="content_coreTechnologyBox">
                    <img v-lazy="aboutImg.picture5" />

                    <!-- <img src="~@/assets/images/BOSPictureOne.png" /> -->
                    <p>
                      媒体策略<br />事件创造<br />形象推广<br />户外广告<br />促销策略<br />全方位设计<br />
                    </p>
                  </div>
                </div>
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 业务布局 -->
      <!-- <el-row>
        <el-col :span="24">
          <div class="content_space content_ourService">
            <div class="title">
              <h3>业务布局</h3>
              <i class="lineTitel"></i>
            </div>
            <el-row>
              <el-col :span="24">
                <el-tabs v-model="activeName" type="card">
                  <el-tab-pane label="国内布局" name="first">
                    <img v-lazy="aboutImg.picture6" />

                    <div class="tabContent">
                      <ul>
                        <li>进驻<span>18</span>城市</li>
                        <li><span>3000+</span>门店</li>
                        <li><span>50000+</span>在职员工</li>
                      </ul>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="海外布局" name="second">
                    <img v-lazy="aboutImg.picture7" style="margin-top: 100px" />
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row> -->
      <!-- 合作伙伴 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space cooperative_partner">
            <div class="title">
              <h3>合作伙伴</h3>
              <i class="lineTitel"></i>
            </div>
            <div class="tips">
              <span>12</span
              >年用心专业服务<span>40</span>多家百强开发商，与<span>300</span>余家开发商建立良好合作关系<br />与<span
                >绿地，正荣，恒大，碧桂园，中粮，中建，福晟</span
              >
              等众多知名企业达成战略合作
            </div>
            <el-row>
              <el-col :span="24">
                <div class="partnerContent">
                  <ul>
                    <li>
                      <!-- <img src="~@/assets/images/BOSWF.png" /> -->
                      <img v-lazy="aboutImg.picture8" />
                    </li>
                    <li>
                      <!-- <img src="~@/assets/images/BOSEvergrande.png" /> -->
                      <img v-lazy="aboutImg.picture9" />
                    </li>
                    <li>
                      <!-- <img src="~@/assets/images/BOSLongfor.png" /> -->
                      <img v-lazy="aboutImg.picture10" />
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture11" />

                      <!-- <img src="~@/assets/images/BOSGreenland.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture12" />

                      <!-- <img src="~@/assets/images/BOSWanda.png" /> -->
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <img v-lazy="aboutImg.picture13" />

                      <!-- <img src="~@/assets/images/BOSJiuchuangCapital.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture14" />

                      <!-- <img src="~@/assets/images/BOSWanKe.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture15" />

                      <!-- <img src="~@/assets/images/BOSXuhui.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture16" />

                      <!-- <img src="~@/assets/images/BOSKaisa.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture17" />

                      <!-- <img src="~@/assets/images/BOSSUNING.png" /> -->
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <img v-lazy="aboutImg.picture18" />

                      <!-- <img src="~@/assets/images/BOSOnlyHunting.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture19" />

                      <!-- <img src="~@/assets/images/BOSMinmetals.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture20" />

                      <!-- <img src="~@/assets/images/BOSCSCEC.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture21" />

                      <!-- <img src="~@/assets/images/BOSCMCREALESTATE.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture22" />

                      <!-- <img src="~@/assets/images/BOSWangfujing.png" /> -->
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <img v-lazy="aboutImg.picture23" />

                      <!-- <img src="~@/assets/images/BOSLianTrankcs.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture24" />

                      <!-- <img src="~@/assets/images/BOSSHIMA.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture25" />

                      <!-- <img src="~@/assets/images/BOSRiseSun.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture26" />

                      <!-- <img src="~@/assets/images/BOSRadioTelevision.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture27" />

                      <!-- <img src="~@/assets/images/BOSWalmart.png" /> -->
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <img v-lazy="aboutImg.picture28" />

                      <!-- <img src="~@/assets/images/BOSTsinghua.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture29" />

                      <!-- <img src="~@/assets/images/BOSXinHuaCapital.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture30" />

                      <!-- <img src="~@/assets/images/BOSZhonghai.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture31" />

                      <!-- <img src="~@/assets/images/BOSSyngenetic.png" /> -->
                    </li>
                    <li>
                      <img v-lazy="aboutImg.picture32" />

                      <!-- <img src="~@/assets/images/BOSMETRO.png" /> -->
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style>
.el-carousel__container {
  height: 625px !important;
}

.el-carousel__button {
  border-radius: 50%;
  width: 10px !important;
  height: 10px !important;
}

.el-carousel__indicator--horizontal {
  padding: 12px 21px 39px 0 !important;
}
</style>
<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  img[lazy="loading"] {
    display: inline-block;
    width: 50px;
    height: 50px;
    margin: 0 auto;
  }

  .scene_top {
    // background: url(~@/assets/images/BOSHomeBackgroundOne.png) no-repeat;
    background-size: 100% 100%;
    height: 593px;
    width: 100%;
    color: #ffffff;
    position: relative;
    .scene_topContent {
      text-align: left;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h1 {
        padding-bottom: 22px;
        font-size: 48px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
      }
      p {
        font-size: 20px;
        font-family: MicrosoftYaHeiLight;
        font-weight: 400;
        text-align: center;
      }
    }
  }

  .homePage {
    padding: 49px 261px 26px 260px;
    .homePageOneInfos {
      display: flex;
      justify-content: center;
      ul li {
        list-style: none;
        font-size: 24px;
      }
      .homePageInfo1 {
        li:nth-of-type(1) {
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          justify-content: space-between;
          p:nth-of-type(1) {
            background: #27439f;
            width: 354px;
            height: 106px;
            display: flex;
            justify-content: space-around;
            text-align: center;
            align-items: baseline;
          }
          p strong {
            font-size: 78px;
          }
          p:nth-of-type(1) strong {
            color: #fefefe;
          }

          p:nth-of-type(2) strong {
            color: #a7823c;
            padding-left: 21px;
          }
          p span {
            font-size: 24px;
            color: #fefefe;
          }
        }
        li:nth-of-type(2) {
          margin-top: 7px;
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          color: #27439f;
          p:nth-of-type(1) {
            border: 3px solid #27439f;
            width: 354px;
            height: 215px;
            box-sizing: border-box;
            padding: 0 23px 0 22px;
          }

          p:nth-of-type(2) {
            padding-left: 25px;
          }
          p:nth-of-type(1) strong {
            text-align: left;
            font-size: 78px;
            color: #27439f;
            display: block;
          }
          p:nth-of-type(2) strong {
            width: 124px;
            height: 94px;
            font-size: 120px;
            font-family: MicrosoftYaHei;
            font-weight: bold;
            color: #27439f;
          }
          p:nth-of-type(1) span {
            font-size: 24px;
            width: 159px;
            height: 54px;
            display: inline-block;
            text-align: left;
            position: relative;
            top: -79px;
            left: 85px;
          }
          p:nth-of-type(2) span {
            // font-size: 120px;
            // font-family: MicrosoftYaHei;
            // font-weight: bold;
            // color: #27439f;
            // line-height: 80px;
          }
        }
        li:nth-of-type(3) {
          margin-top: 8px;
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          color: #fff;
          text-align: left;
          p:nth-of-type(1) {
            background: #a7823c;
            width: 275px;
            height: 176px;
            margin-right: 8px;
            strong,
            span {
              margin-left: 17px;
            }

            strong {
              font-size: 78px;
            }
          }

          p:nth-of-type(2) {
            background: #27439f;
            width: 275px;
            height: 176px;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            > span:nth-of-type(1) {
              // width: 54px;
              height: 144px;
              display: block;
              writing-mode: vertical-rl; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
              writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
              margin-top: 16px;
            }
            strong {
              font-size: 120px;
            }

            > span:nth-of-type(2) {
              margin-top: 133px;
            }
          }
          p span {
            font-size: 24px;
          }
        }
        li:nth-of-type(4) {
          margin-top: 7px;
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          color: #27439f;
          border: 3px solid #27439f;
          width: 558px;
          height: 189px;
          box-sizing: border-box;
          p:nth-of-type(1) {
          }
          p strong {
            font-size: 78px;
            margin-left: 48px;
            line-height: 86px;
          }
          p span {
            font-size: 24px;
            width: 159px;
            display: inline-block;
            text-align: left;
            float: right;
            margin-top: 15px;
            margin-right: -28px;
          }
        }
        li:nth-of-type(5) {
          margin-top: 7px;
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          color: #27439f;
          p:nth-of-type(1) {
            width: 558px;
            height: 67px;
            display: flex;
            justify-content: space-between;
            text-align: left;
          }
          p strong {
            font-size: 46px;
          }
          p span {
            font-size: 24px;
          }
        }
      }

      .homePageInfo2 {
        margin: 0 7px 0 0;
        li:nth-of-type(1) {
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          color: #a7823c;
          width: 275px;
          height: 120px;
          p {
            font-size: 24px;
            display: flex;
            align-items: flex-end;
            margin-bottom: 33px;
            margin-left: 14px;
          }
        }
        li:nth-of-type(2) {
          margin-top: 7px;
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          background: #a7823c;
          color: #fefefe;
          width: 275px;
          height: 111px;
          justify-content: space-between;
          strong {
            font-size: 78px;
            margin-left: 19px;
          }
          span {
            font-size: 24px;
            display: flex;
            align-items: center;
            width: 96px;
            margin-right: 17px;
          }
        }
        li:nth-of-type(3) {
          margin-top: 7px;
          width: 275px;
          height: 151px;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          color: #27439f;

          strong {
            font-size: 62px;
            width: 189px;
            height: 121px;
            display: inherit;
            text-align: left;
            margin-left: 18px;
          }
          span {
            font-size: 22px;
            display: block;
            width: 146px;
            height: 53px;
            margin-top: -27px;
            float: right;
            text-align: left;
            margin-right: -10px;
          }
        }
        li:nth-of-type(4) {
          margin-top: 7px;
          width: 275px;
          height: 185px;
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          color: #27439f;
          border: 3px solid #27439f;
          box-sizing: border-box;

          strong {
            font-size: 62px;
            width: 189px;
            height: 119px;
            text-align: left;
            margin-left: 20px;
          }
          span {
            font-size: 24px;
            width: 96px;
            height: 55px;
            display: inline-block;
            margin-top: 91px;
            margin-left: -60px;
            margin-right: 24px;
          }
        }
        li:nth-of-type(5) {
          margin-top: 7px;

          width: 275px;
          height: 185px;
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          background: #a7823c;
          color: #fefefe;
          strong {
            font-size: 78px;
            margin-top: 24px;
            margin-left: 21px;
          }
          sub {
            margin-top: 24px;
          }
          span {
            font-size: 20px;
            display: flex;
            align-items: flex-end;
            margin-bottom: 15px;
            margin-right: 10px;
            text-align: left;
          }
        }
      }

      .homePageInfo3 {
        li:nth-of-type(1) {
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          border: 3px solid #27439f;
          color: #27439f;
          width: 545px;
          height: 239px;
          box-sizing: border-box;
          justify-content: space-between;
          strong {
            font-size: 78px;
            padding-left: 29px;
          }
          span {
            font-size: 24px;
            display: flex;
            align-items: flex-end;
            margin-bottom: 21px;
            margin-right: 31px;
          }
        }
        li:nth-of-type(2) {
          margin-top: 7px;
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          background: #27439f;
          color: #fefefe;
          width: 545px;
          height: 178px;
          strong {
            font-size: 64px;
            text-align: left;
            margin-left: 24px;
          }
          span {
            font-size: 24px;
            display: flex;
            align-items: flex-end;
            margin-bottom: 22px;
            margin-right: 24px;
            text-align: left;
          }
        }
        li:nth-of-type(3) {
          margin-top: 7px;
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          border: 3px solid #a7823c;
          color: #a7823c;
          width: 545px;
          height: 112px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;

          strong {
            font-size: 62px;
            margin-left: 24px;
          }
          span {
            font-size: 24px;
            margin-right: 24px;
            margin-top: 22px;
          }
        }
        li:nth-of-type(4) {
          margin-top: 7px;
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          color: #27439f;
          width: 545px;
          height: 112px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          strong {
            font-size: 78px;
            margin-left: 24px;
          }
          span {
            font-size: 24px;
            width: 132px;
            height: 55px;
            display: inline-block;
            margin-right: 24px;
          }
        }
        li:nth-of-type(5) {
          box-sizing: border-box;
          margin-top: 7px;
          display: flex;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          background: #27439f;
          color: #fefefe;
          width: 545px;
          height: 112px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          strong {
            font-size: 62px;
            margin-left: 24px;
          }
          span {
            font-size: 24px;
            margin-right: 24px;
            width: 168px;
            height: 54px;
            display: inline-block;
            text-align: left;
          }
        }
      }
    }
  }

  //1 公共样式
  .content_space {
    // background: url(~@/assets/images/bg.png) no-repeat;
    // padding: 49px 261px 56px 260px;
    .title {
      font-size: 30px;
      font-family: MicrosoftYaHeiLight;
      font-weight: bold;
      color: #000000;
      h3 {
        font-size: 30px;
        font-weight: 400;
        margin-bottom: 25px;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 87px;
      }
    }
    .content {
      width: 304px;
      margin: auto;
      font-weight: 400;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      h4 {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        margin: 43px 0 44px 0;
      }
      p {
        font-size: 16px;
        font-family: MicrosoftYaHeiLight;
        line-height: 32px;
        height: 190px;
      }

      .el-button {
        margin-top: 23px;
        border-radius: 25px;
        a {
          text-decoration: none;
          color: #3d3d3d;
        }
      }

      .el-button:hover,
      .el-button:focus {
        background: #e9471a;
      }

      .el-button:hover a,
      .el-button:focus a {
        color: #fff;
      }
    }
  }

  //核心技术
  .content_coreTechnology {
    background: none;
    padding: 49px 260px 13px 259px;
    .title {
      border-top: 1px #f6f6f6 solid;
      padding-top: 30px;
      margin-bottom: 34px;
      h3 {
        margin-bottom: 0 !important;
      }
      .lineTitel {
        width: 76px;
        height: 5px;
        background: #a7823c;
        display: inline-block;
        position: relative;
        top: -13px;
      }
    }

    .serviceSystem {
      display: flex;
      justify-content: space-between;
      > div {
        width: 246px;
        height: 534px;
        margin-right: 43px;
        border: 1px solid #dddddd;
      }

      > div:last-of-type {
        margin-right: 0;
      }

      .content {
        h4 {
          font-size: 20px;
          font-family: MicrosoftYaHei;
          margin: 26px 0 20px 0;
        }
      }

      .content_coreTechnologyBox {
        img {
          width: 201px;
          height: 133px;
        }
      }
    }

    .content:hover {
      background: #27439f;
      color: #fff;
    }
  }

  //合作伙伴
  .cooperative_partner {
    background: none;
    padding: 49px 260px 56px 259px;
    .title {
      border-top: 1px #f6f6f6 solid;
      padding-top: 30px;
      h3 {
        margin-bottom: 0 !important;
      }
      .lineTitel {
        width: 76px;
        height: 5px;
        background: #a7823c;
        display: inline-block;
        position: relative;
        top: -13px;
      }
    }
    .tips {
      font-size: 16px;
      margin: 0 auto;
      margin-top: 38px;
      margin-bottom: 75px;
      line-height: 32px;
      span {
        font-size: 20px !important;
        font-weight: bold;
        color: #28449f;
        margin: 0 4px;
      }
    }

    .partnerContent {
      display: flex;
      justify-content: space-between;
      ul li {
        list-style: none;
      }
    }
  }

  // 业务布局
  .content_ourService {
    background: none;
    padding: 49px 260px 56px 259px;

    .title {
      border-top: 1px #f6f6f6 solid;
      padding-top: 30px;
      margin-bottom: 34px;
      h3 {
        margin-bottom: 0 !important;
      }
      .lineTitel {
        width: 76px;
        height: 5px;
        background: #a7823c;
        display: inline-block;
        position: relative;
        top: -13px;
      }
    }

    .content {
      // width: 440px;
      background: #fafafa;
      border-radius: 10px;
      font-family: MicrosoftYaHei;
      width: auto;
      margin: 0 20px;

      img {
        max-width: 192px !important;
        max-height: 192px !important;
      }
      h4 {
        font-size: 20px;
        padding: 39px 0 24px 0;
        margin: 0;
      }
      > p:nth-of-type(1) {
        font-size: 16px;
        height: 35px;
        margin-bottom: 31px;
      }
      > p:nth-of-type(2) {
        // width: 387px;
        font-size: 16px;
        margin: 0 auto;
        height: 100px;
        padding: 24px 20px 88px 20px;
        text-align: left;
      }
    }

    .tabContent {
      position: absolute;
      top: 85px;
      left: 628px;
      font-size: 20px;
      text-align: left;
      ul li {
        list-style: none;
        span {
          color: #27439f;
        }
      }
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";
import picUr1Two from "@/assets/images/BOSHomeBackgroundOne.png";
import aboutImgOne from "@/assets/images/BOSPictureFive.png";
import aboutImgTwo from "@/assets/images/BOSPictureFour.png";
import aboutImgThree from "@/assets/images/BOSPictureThree.png";
import aboutImgFour from "@/assets/images/BOSPictureTwo.png";
import aboutImgFive from "@/assets/images/BOSPictureOne.png";
import aboutImgSix from "@/assets/images/BOSWorldMap2.png";
import aboutImgSeven from "@/assets/images/BOSWorldMap.png";
import aboutImgEight from "@/assets/images/BOSWF.png";
import aboutImgNine from "@/assets/images/BOSEvergrande.png";
import aboutImgTen from "@/assets/images/BOSLongfor.png";
import aboutImgTelve from "@/assets/images/BOSGreenland.png";
import aboutImgEleven from "@/assets/images/BOSWanda.png";
import aboutImgThirteen from "@/assets/images/BOSJiuchuangCapital.png";
import aboutImgFourteen from "@/assets/images/BOSWanKe.png";
import aboutImgFifteen from "@/assets/images/BOSXuhui.png";
import aboutImgSixteen from "@/assets/images/BOSKaisa.png";
import aboutImgSeventeen from "@/assets/images/BOSSUNING.png";
import aboutImgEighteen from "@/assets/images/BOSOnlyHunting.png";
import aboutImgNineteen from "@/assets/images/BOSMinmetals.png";
import aboutImgTwenty from "@/assets/images/BOSCSCEC.png";
import aboutImgTwentyOne from "@/assets/images/BOSCMCREALESTATE.png";
import aboutImgTwentyTwo from "@/assets/images/BOSWangfujing.png";
import aboutImgTwentyThree from "@/assets/images/BOSLianTrankcs.png";
import aboutImgTwentyFour from "@/assets/images/BOSSHIMA.png";
import aboutImgTwentyFive from "@/assets/images/BOSRiseSun.png";
import aboutImgTwentySix from "@/assets/images/BOSRadioTelevision.png";
import aboutImgTwentySeven from "@/assets/images/BOSWalmart.png";
import aboutImgTwentyEight from "@/assets/images/BOSTsinghua.png";
import aboutImgTwentyNine from "@/assets/images/BOSXinHuaCapital.png";
import aboutImgThirty from "@/assets/images/BOSZhonghai.png";
import aboutImgThirtyOne from "@/assets/images/BOSSyngenetic.png";
import aboutImgThirtyTwo from "@/assets/images/BOSMETRO.png";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  data() {
    return {
      dataList: [
        //轮播图内容
        {
          url: "~@/assets/images/banner1.png",
          titleOne: "公共空间智能化服务商",
          titleTwo:
            "用数据和科技构建万物互联的智慧数字空间，实现空间与数据及人的融合，让空间服务更高效。",
        },
        {
          url: "~@/assets/images/banner1.png",
          titleOne: "物联网+人工智能（AIoT）赋能空间",
          titleTwo:
            "用数据和科技构建万物互联的智慧数字空间，实现空间与数据及人的融合，让空间服务更高效。",
        },
        {
          url: "~@/assets/images/banner1.png",
          titleOne: "构建万物互联的数智化空间",
          titleTwo:
            "用数据和科技构建万物互联的智慧数字空间，实现空间与数据及人的融合，让空间服务更高效。",
        },
      ],
      applicationScenario: [
        //应用场景
        {
          url: "@/assets/images/banner1.png",
          title: "智慧园区",
          content:
            "帮助产业园区、政府园区、工业园区等多类型项目的持有方、运营方、管理方实现业务模式创新升级。通过资源聚合，数字化、管理智能化、招商多元化、运营智慧化，利用新技术聚产业、集人才、展新城，构建可持续发展的产业集群。",
        },
        {
          url: "@/assets/images/banner1.png",
          title: "智慧园区",
          content:
            "帮助产业园区、政府园区、工业园区等多类型项目的持有方、运营方、管理方实现业务模式创新升级。通过资源聚合，数字化、管理智能化、招商多元化、运营智慧化，利用新技术聚产业、集人才、展新城，构建可持续发展的产业集群。",
        },
        {
          url: "@/assets/images/banner1.png",
          title: "智慧园区",
          content:
            "帮助产业园区、政府园区、工业园区等多类型项目的持有方、运营方、管理方实现业务模式创新升级。通过资源聚合，数字化、管理智能化、招商多元化、运营智慧化，利用新技术聚产业、集人才、展新城，构建可持续发展的产业集群。",
        },
        {
          url: "@/assets/images/banner1.png",
          title: "智慧园区",
          content:
            "帮助产业园区、政府园区、工业园区等多类型项目的持有方、运营方、管理方实现业务模式创新升级。通过资源聚合，数字化、管理智能化、招商多元化、运营智慧化，利用新技术聚产业、集人才、展新城，构建可持续发展的产业集群。",
        },
      ],
      tabIndex: "1",
      activeName: "first",
      imgLink: picUr1Two,
      aboutImg: {
        picture1: aboutImgOne,
        picture2: aboutImgTwo,
        picture3: aboutImgThree,
        picture4: aboutImgFour,
        picture5: aboutImgFive,
        picture6: aboutImgSix,
        picture7: aboutImgSeven,
        picture8: aboutImgEight,
        picture9: aboutImgNine,
        picture10: aboutImgTen,
        picture11: aboutImgTelve,
        picture12: aboutImgEleven,
        picture13: aboutImgThirteen,
        picture14: aboutImgFourteen,
        picture15: aboutImgFifteen,
        picture16: aboutImgSixteen,
        picture17: aboutImgSeventeen,
        picture18: aboutImgEighteen,
        picture19: aboutImgNineteen,
        picture20: aboutImgTwenty,
        picture21: aboutImgTwentyOne,
        picture22: aboutImgTwentyTwo,
        picture23: aboutImgTwentyThree,
        picture24: aboutImgTwentyFour,
        picture25: aboutImgTwentyFive,
        picture26: aboutImgTwentySix,
        picture27: aboutImgTwentySeven,
        picture28: aboutImgTwentyEight,
        picture29: aboutImgTwentyNine,
        picture30: aboutImgThirty,
        picture31: aboutImgThirtyOne,
        picture32: aboutImgThirtyTwo,
      },
    };
  },
  methods: {},
  computed: {},
};
</script>